import { api, unwrap, type APIResponse } from "./client";

export interface BwCdrUpload {
  filename: string;
  rows_loaded: number;
  rows_skipped: number;
  min_call_start: string | null;
  max_call_start: string | null;
  created_at: string | null;
}
export interface BwCdrSummary {
  rows: number;
  earliest: string | null;
  latest: string | null;
  uploads: BwCdrUpload[];
}
export interface Reconcile {
  usr_id: number;
  period_start: string;
  period_end: string;
  bandwidth: { connected_calls: number; raw_minutes: number };
  ours: { answered_calls: number; minutes: number };
  captured_pct: number | null;
  note: string;
}
export interface InvoiceRow {
  billing_run_id: number;
  usr_id: number;
  invoice_number: string;
  period_start: string;
  period_end: string;
  subtotal: number;
  usf_fee: number;
  total: number;
  status: string;
  created_at: string | null;
}
export interface InvoiceLine {
  type: string;
  description: string;
  quantity: number;
  unit_rate: number;
  amount: number;
}
export interface InvoiceDetail extends InvoiceRow {
  username: string;
  email: string | null;
  company: string | null;
  lines: InvoiceLine[];
}

export async function getBwCdrSummary(): Promise<BwCdrSummary> {
  const resp = await api.get<APIResponse<BwCdrSummary>>("/invoicing/bw-cdr/summary");
  return unwrap(resp.data);
}
export async function uploadBwCdr(file: File): Promise<{ queued: boolean; message: string }> {
  const fd = new FormData();
  fd.append("file", file);
  const resp = await api.post<APIResponse<{ queued: boolean; message: string }>>(
    "/invoicing/bw-cdr/upload", fd, { headers: { "Content-Type": "multipart/form-data" } },
  );
  return unwrap(resp.data);
}
export async function reconcile(usrId: number, periodStart: string, periodEnd: string): Promise<Reconcile> {
  const resp = await api.get<APIResponse<Reconcile>>("/invoicing/reconcile", {
    params: { usr_id: usrId, period_start: periodStart, period_end: periodEnd },
  });
  return unwrap(resp.data);
}
export async function generateInvoice(usrId: number, periodStart: string, periodEnd: string): Promise<InvoiceRow & { status: string }> {
  const resp = await api.post<APIResponse<any>>("/invoicing/generate", {
    usr_id: usrId, period_start: periodStart, period_end: periodEnd,
  });
  return unwrap(resp.data);
}
export async function listInvoices(usrId?: number): Promise<InvoiceRow[]> {
  const resp = await api.get<APIResponse<InvoiceRow[]>>("/invoicing/invoices", {
    params: usrId ? { usr_id: usrId } : {},
  });
  return unwrap(resp.data);
}
export async function getInvoice(id: number): Promise<InvoiceDetail> {
  const resp = await api.get<APIResponse<InvoiceDetail>>(`/invoicing/invoices/${id}`);
  return unwrap(resp.data);
}
